import { Location } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { GlobalService } from 'src/app/_services/global.service';
@Component({
    selector: 'app-project-details',
    templateUrl: './project-details.component.html',
    styleUrls: ['./project-details.component.scss'],
    standalone: false
})
export class ProjectDetailsComponent implements OnInit {

  showProjectDetailsTab: Boolean = true;
  showEvaluationCriteriaTab: Boolean = false;
  showProjectLoader: Boolean = false;

  projectnumber: string = '';
  projectDetails: any;

  successMessage: String = '';
  errorMessage: String = '';
  showSpinnerLoader: Boolean = false;

  /** Regex to check valid project name */
  inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;


  /** Handler rename project */
  renameProjectInput: UntypedFormControl = new UntypedFormControl(null);
  renameProjectInputError: Boolean = false;
  renameProjectInputSpecialCharError: Boolean = false;
  dublicateProjectNameError: boolean = false;
  selectedRenameProject: any;
  projectDescription:any;
  targetIndustries:any;
  projectSkills:any;
  targetCompanies:any;

  tab: Boolean = true;
  infoMessage: string = '';
  functions:any;
  showActivityTab:boolean= false
  tabName:any
  isTabActive:boolean=false
  @ViewChild('renameProjectModel') renameProjectModel: TemplateRef<any>;
  @ViewChild('handleBackEventModel') handleBackEventModel: TemplateRef<any>;
  activeTab: string = '';

  constructor(
    private modelService: NgbModal,
    private router: Router,
    private locationService: Location,
    private aiSourcingService: AiSourcingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private route: ActivatedRoute
  ) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      this.setActiveTab(event.url);
    });
   }


  ngOnInit() {
    this.projectnumber = window.location.pathname?.split('/')[3];
    this.tabName = window.location.pathname?.split('/')[4]
    this.aiSourcingHandlerService.setEvaluationTabEvent(false);
    this.getProjectDetails();

    this.renameProjectInput.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((value: any) => {
      if (value && value.length > 0 && !this.inputRegex.test(value)) {
        this.renameProjectInputSpecialCharError = true;
      } else {
        this.renameProjectInputSpecialCharError = false;
      }
      this.getDuplicateProjectNameError(value);
      this.renameProjectInputError = false;
    });

  }
 setActiveTab(url: string) {
  if (url.includes('autopilot-evaluation-criteria')) {
    this.activeTab = 'autopilot-evaluation-criteria';
     this.showEvaluationCriteriaTab = true;
      this.showProjectDetailsTab = false;
      this.showActivityTab = false
  } else if (url.includes('autopilot-activity')) {
    this.activeTab = 'autopilot-activity';
     this.showEvaluationCriteriaTab = false;
      this.showProjectDetailsTab = false;
      this.showActivityTab = true
  } else if (url.includes('project-details')) {
    this.activeTab = 'project-tab';
    this.showEvaluationCriteriaTab = false;
      this.showProjectDetailsTab = true;
      this.showActivityTab = false
  }
}
  /**
   * Method to check if the project name already exists.
   * @param projectName
   */
  getDuplicateProjectNameError(projectName: string) {
    this.aiSourcingService.isDuplicateProjectName(projectName).subscribe((response: any) => {
      if (response && response.status == 'success') {
        if (response && response.duplicate) {
          this.dublicateProjectNameError = true;
        } else {
          this.dublicateProjectNameError = false;
        }
      } else {
        this.dublicateProjectNameError = false;
      }
    })
  };

  /**
   * Method to handle change tab
   * @param type
   */
  onTabChange(type: String) {
    switch (type) {
      case 'project-tab': {
        this.showProjectDetailsTab = true;
        this.showEvaluationCriteriaTab = false;
         this.showActivityTab = false
        this.aiSourcingHandlerService.setEvaluationTabEvent(false);
        this.router.navigate(['/ai-sourcing/project-details/' + this.projectnumber]);
        break;
      }

      case 'evaluation-tab': {
        this.showEvaluationCriteriaTab = true;
        this.showProjectDetailsTab = false;
         this.showActivityTab = false
        this.aiSourcingHandlerService.setEvaluationTabEvent(true);
        this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}/autopilot-evaluation-criteria`]);
        break;
      }

      case 'activity-tab': {
        this.showEvaluationCriteriaTab = false;
        this.showProjectDetailsTab = false;
         this.showActivityTab = true
        this.aiSourcingHandlerService.setEvaluationTabEvent(false);
         this.router.navigate([`/ai-sourcing/project-details/${this.projectnumber}/autopilot-activity`]);
        break;
      }
    }
  };

  /**
   * Method to fetch project details
   */
  getProjectDetails() {
    this.showProjectLoader = true;
    this.aiSourcingService.getProjectDetails(this.projectnumber).subscribe((res: any) => {
      this.showProjectLoader = false;
      if (res && res.status == 'success') {
        this.projectDetails = res.data;
         this.projectDetails.jobdescription = this.projectDetails.jobdescription.replace(/\n/g, "<br>");
        this.projectDescription = this.projectDetails.jobdescription;
       // this.projectDescription = this.removeSpecialCharacters(this.projectDescription);
        this.targetIndustries = this.projectDetails.industries;
          this.projectSkills=this.projectDetails.skills;
          this.targetCompanies=this.projectDetails.companies;
          this.functions=this.projectDetails.functions;
      } else {
        this.projectDetails = {};
      }
    })
  };
removeSpecialCharacters(input: string): string {
    return input?.replace(/[^a-zA-Z0-9 ]/g, '');
  }
  /**
   * Method to handle the renaming of a project.
   */
  openRenameProjectModel(project: any) {
    this.selectedRenameProject = project;
    this.renameProjectInput.setValue(project?.projectname ? project?.projectname : null);
    this.modelService.open(this.renameProjectModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Rename project name
   * @returns
   */
  renameProject() {
    if ((!this.renameProjectInput.value && !this.selectedRenameProject?.projectnumber) || this.renameProjectInputSpecialCharError) return;
    this.showSpinnerLoader = true;
    const projectName = {
      projectname: this.renameProjectInput.value.trim()
    };
    const projectNumber = this.selectedRenameProject?.projectnumber;

    this.aiSourcingService.renameProject(projectNumber, projectName).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.successMessage = res.body.message;
        this.getProjectDetails();
        this.renameProjectInput.setValue(null);
        this.renameProjectInputError = false;
        this.selectedRenameProject = null;
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = res.body.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.dismiss();
      this.showSpinnerLoader = false;
    }, (err) => {
      this.errorMessage = err.error.message;
      setTimeout(() => this.errorMessage = '', 5000);
      this.showSpinnerLoader = false;
    })
  }

  /**
   * Methos to use open handle back event model
   */
  openHandleBackEventModel() {
    this.modelService.open(this.handleBackEventModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
  * Methos to use go to project list
  * If user wants to back
  */
  handleBackEvent() {
    this.locationService.back();
    // this.router.navigate(['/ai-sourcing/project-list']);
    // this.dismiss();
  };

  /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
    this.showSpinnerLoader = false;
  }

  /**
   *
   * @param string
   * @returns
   */
  chipCleanUp(input: string | string[]) {
    let arr: string[] = [];

    if (typeof input === 'string') {
      arr = [input];
    } else {
      arr = input;
    }

    const cleaned = arr?.map(item =>
      item.includes('.aisearch') ? item?.split('.aisearch')[0] : item
    );

    if (typeof input === 'string') {
      return cleaned[0];
    }

    return cleaned?.join(', ');
  };

    getIndustryIcon(industryName){
      let iconName = GlobalService.getIndustryIcon(industryName.toLowerCase())
      return `fa-solid fa-${iconName}`
    }

  /**
   * Method to navigate to the edit project page
   */
  editProjects() {
    this.router.navigate([`/ai-sourcing/jd-description/${this.projectnumber}`], { queryParams: { source: 'edit' } });
  };
}
